import { useState, useContext } from 'react';
import { NotificationDispatch, RedeemTicketButton, Ticket, SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { TicketName } from '@tryhackme/thm-ui-components/dist/components/atoms/ticket/ticket.types';
import { TicketProps } from 'src/features/public-profile/components/tickets-tab/tickets.types';
import { useGetPublicProfileTicketsQuery, useRedeemTicketMutation } from 'src/features/public-profile/components/tickets-tab/tickets.slice';
import { PublicProfileTicket } from 'src/common/interfaces/public-profile';
import { StyledTicketCategoryWrapper, StyledTickets, StyledFooter, StyledHoverButtonWrapper } from 'src/features/public-profile/components/tickets-tab/tickets.styles';
import { StyledLoading, StyledNoItemsText, StyledTabPaper } from 'src/features/public-profile/public-profile.styles';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { ApiResponseStatus, ThemeColorMode } from 'src/common/enums';
export const TicketsTab = ({
  userId
}: TicketProps) => {
  const [hoveredTicket, setHoveredTicket] = useState<string | null>(null);
  const {
    data,
    isLoading
  } = useGetPublicProfileTicketsQuery({
    user: userId
  }, {
    skip: !userId
  });
  const [redeemTicket] = useRedeemTicketMutation();
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDark = theme === ThemeColorMode.DARK;
  if (isLoading) {
    return <StyledTabPaper withoutBg data-testid="loading">
        <StyledLoading />
      </StyledTabPaper>;
  }
  if (data?.data?.length === 0) {
    return <StyledTabPaper>
        <StyledNoItemsText>This user has not collected any tickets yet</StyledNoItemsText>
      </StyledTabPaper>;
  }
  const onRedeemTicket = async (ticketName: string) => {
    try {
      const response = await redeemTicket({
        ticketName
      }).unwrap();
      if (response.status === ApiResponseStatus.SUCCESS) {
        NotificationDispatch('success', 'Successfully redeemed ticket');
      } else {
        NotificationDispatch('error', response.data);
      }
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  return <StyledTabPaper withoutBg data-sentry-element="StyledTabPaper" data-sentry-component="TicketsTab" data-sentry-source-file="tickets-tab.tsx">
      {data?.data?.length && <>
          <StyledTickets>
            {data?.data.map((ticket: PublicProfileTicket) => <StyledTicketCategoryWrapper data-testid="ticket-category-wrapper" key={ticket.name} onMouseEnter={() => ticket.count > 2 && !ticket.redeemed && setHoveredTicket(ticket.name)} onMouseLeave={() => setHoveredTicket(null)} isHovered={ticket.count > 2 && !ticket.redeemed && ticket.name === hoveredTicket && ticket.automaticRedeem}>
                <Ticket name={(ticket.name as TicketName)} isCollected={ticket.count > 0 && !ticket.redeemed && !(ticket.name === hoveredTicket && !ticket.redeemed)} />
                <Ticket name={(ticket.name as TicketName)} isCollected={ticket.count > 1 && !ticket.redeemed && !(ticket.name === hoveredTicket && !ticket.redeemed)} />
                <Ticket name={(ticket.name as TicketName)} isCollected={ticket.count > 2 && !ticket.redeemed && !(ticket.name === hoveredTicket && !ticket.redeemed)} />
                {(!!ticket.redeemed || ticket.name === hoveredTicket) && <StyledHoverButtonWrapper>
                    <RedeemTicketButton isRedeemed={!!ticket.redeemed} name={ticket.redeemed ? (ticket.name as TicketName) : 'redeem'}
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={() => !ticket.redeemed && onRedeemTicket(ticket.name)} />
                  </StyledHoverButtonWrapper>}
              </StyledTicketCategoryWrapper>)}
          </StyledTickets>
          <StyledFooter $isDark={isDark}>
            This event has now ended, but keep an eye on our social media accounts for future ticketing promotions!
          </StyledFooter>
        </>}
    </StyledTabPaper>;
};